module.exports = __webpack_public_path__ + "ptc_momoro_G1_2.e9d2a674.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_G1_2.jpg
// module id = wFOL
// module chunks = 0